// src/lib/anzeige.js
// SCHRIFTGROESSE DER APP (Anna-Lena 04.10.2026)
//
// Die Monteure sind teils ueber 40 und arbeiten im Dunkeln mit Handschuhen.
// Hier stellt jeder auf seinem Geraet ein, wie gross alles dargestellt wird.
//
// Technik: Wir skalieren die GANZE Seite ueber die CSS-Eigenschaft `zoom` am
// <html>-Element. Dadurch wachsen Schrift, Knoepfe und Abstaende gleichmaessig
// mit - es muessen nicht hunderte fester Pixelwerte angefasst werden, und die
// Abstaende bleiben im Verhaeltnis richtig (eine groessere Schrift in einem
// gleich grossen Knopf wuerde sonst herauslaufen).
//
// Bewusst gibt es KEINE Stufe unter 100 %: Ein Eingabefeld unter 16 px laesst
// iOS beim Antippen automatisch in die Seite hineinzoomen - die Ansicht springt
// dann. Siehe inputStyle in pages/formui.js.

const SCHLUESSEL = 'etb-schriftgroesse';

export const SCHRIFT_STUFEN = [
  { wert: 'normal',   faktor: 1,    name: 'Normal' },
  { wert: 'gross',    faktor: 1.15, name: 'Groß' },
  { wert: 'sehrgross', faktor: 1.3, name: 'Sehr groß' },
];

const horcher = new Set();

export function schriftGroesse() {
  try {
    const gemerkt = localStorage.getItem(SCHLUESSEL);
    if (SCHRIFT_STUFEN.some(s => s.wert === gemerkt)) return gemerkt;
  } catch { /* privater Modus o. ae. - dann eben Normal */ }
  return 'normal';
}

export function faktorVon(wert) {
  return (SCHRIFT_STUFEN.find(s => s.wert === wert) || SCHRIFT_STUFEN[0]).faktor;
}

export function schriftAnwenden(wert = schriftGroesse()) {
  if (typeof document === 'undefined') return;
  const faktor = faktorVon(wert);
  // zoom kennen Chrome, Safari und neuere Firefox-Versionen. Kennt es ein
  // Browser nicht, bleibt die App einfach in Normalgroesse - nichts bricht.
  document.documentElement.style.zoom = faktor === 1 ? '' : String(faktor);
}

export function setzeSchriftGroesse(wert) {
  const gueltig = SCHRIFT_STUFEN.some(s => s.wert === wert) ? wert : 'normal';
  try { localStorage.setItem(SCHLUESSEL, gueltig); } catch { /* nur Komfort */ }
  schriftAnwenden(gueltig);
  horcher.forEach(f => { try { f(gueltig); } catch { /* ein Horcher darf nichts umwerfen */ } });
}

export function beiSchriftAenderung(f) {
  horcher.add(f);
  return () => horcher.delete(f);
}

// Beim Laden der App sofort anwenden, damit nichts erst gross und dann klein wird.
schriftAnwenden();
